// Shared helper for refs that mount behind a modal/body transition.
// The body cross-fades use mode="out-in", so on a view→form swap the form (and
// its field refs) only mounts after the outgoing view has finished leaving.
// Poll a few frames until the ref exists instead of a single $nextTick.
export default {
    methods: {
        async WaitForRef(name, tries = 40){
            for(let i = 0; i < tries; i++){
                if(this.$refs[name]) return true;
                await new Promise(resolve => requestAnimationFrame(resolve));
            }
            return false;
        }
    }
};
